
import React,{useState, Component, useEffect, useRef} from 'react';
// import {dateFormat,loadData, loadMaster, uploadImage, dateValue, formatDate} from '../config/projectConfig'
// import {JsonPretty, ElmentShow, FacebookMessageUs, ContactIcon,ContactIconBar,ContactIconSector} from '../config/projectConfig';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {Button, Row, Container, Col, Form, Table, InputGroup, OverlayTrigger, Tooltip, Breadcrumb, Card, CardColumns, Modal} from 'react-bootstrap';
import Resizer from 'react-image-file-resizer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe,faHome, faPhoneSquare, faPlus, faPencilAlt, faTrash} from "@fortawesome/free-solid-svg-icons";
// internal lib
import { AuthUserContext } from '../components/Session'
import { withFirebase } from '../components/Firebase';
import { loadMaster, dateFormat, uploadImage, getCol,uploadImageDynamic } from '../config/dbUtils'
import { LabelTextInput, LabelImageInput, TextInput, ImageInput } from '../config/formUtils'
// page

const PageFuction = (props) => {
  const firebase = props.firebase;
  const firestore = props.firebase.firestore;
  const collection = firestore.collection("car");

  const [carList, setCarList] = useState([]);
  const [carCreate, setCarCreate] = useState({startDate:new Date()})
  const [carUpdate, setCarUpdate] = useState({});
  const [master, setMaster] = useState({});
  const province_master = "carStatus";
  const masterList = ["m1","m2",province_master];

  // modal
  const inputRef = useRef(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const [carCreate, setCarCreate] = useState({}); 
  const carCreateChange = (key,value,index) => { console.log("carCreateChange("+key+","+index+","+value+")"); setCarCreate({ ...carCreate, [key]: value }); }
  const imgChange = (key,value,index,path) => { console.log("imgChange("+key+","+value+","+index+","+path+")"); uploadImageDynamic(firebase,carCreate, setCarCreate, key, value, path); };
  
  // const firestore = firebase.firestore();
  // const collection = firestore.collection("car");
  React.useEffect(()=>{
    const fetchData = async () =>{ getCol(firebase,setCarList,"car") }
    fetchData(0);
    masterList.forEach(m => { loadMaster(firebase, master, setMaster, m); });
  },[]);
  
  const onCreate = async ()=>{ 
    // const dynamicNew = await firestore.collection("dynamic").add({inputList:[],createDate: firebase.firestore.FieldValue.serverTimestamp()});
    const dynamicNew = await firestore.collection("dynamic").add({inputList:[],createDate: firebase.serverTimestamp()});
    console.log("dynamicNew - ",JSON.stringify(dynamicNew.id));
    const companyNew = await firestore.collection("company").add({helmet:[],createDate: firebase.serverTimestamp()});
    console.log("companyNew - ",JSON.stringify(companyNew.id));
    collection.add({...carCreate, element:dynamicNew.id, id_company:companyNew.id,createDate: firebase.serverTimestamp()}); 
  };
  const onDelete = (id)=>{ collection.doc(id).delete(); }
  const onUpdate = (id)=>{ collection.doc(id).set({...carUpdate,createDate: firebase.firestore.FieldValue.serverTimestamp()}); }
  // const carCreateChange = (key,value) => { console.log("Create("+key+","+value+")"); setCarCreate({ ...carCreate, [key]: value }); }
  // const carUpdateChange = (evt,index) => { const carUpdate = carList[index];carUpdate[e.target.name] = evt.target.value; setCarUpdate(carUpdate); }
  const carUpdateChange = (key, value, index) => { console.log("Update("+key+","+value+","+index+")"); const temp = carList[index];temp[key] = value; setCarUpdate(temp); }

  const renderTooltip = (message,props) => (
    <Tooltip id="button-tooltip" {...props}> { JSON.stringify(message)} </Tooltip>
  );

  const handleUploadImage = (image) => {
    uploadImage(firebase, carCreate, setCarCreate, "images", image);
  };
  
  return (
    <>
    <section>
        <Container style={{display:"table",minHeight:"180px"}}>
            <div className="" style={{display:"table-cell",verticalAlign:"middle", fontSize:"40px"}}>
                รายการรถผู้กระทำผิดจอดขวางการจราจร
            </div>
        </Container>
        <Button type="button" style={{marginBottom:"100px"}} className="btn-success" size="lg"
                onClick={() => {handleShow();}}><FontAwesomeIcon icon={faPlus}/> เพิ่มรายการ </Button>
    </section>
  <div className="App">
    <Container>
      <CardColumns>
      {carList ? carList.map((item,index) => (
        <Card key={item.id}>
          <Card.Img variant="top" src={item.carImage != null && item.carImage !== "" ? item.carImage : "appDefault/600x600.webp"} style={{maxHeight:"300px",maxWidth:""}} /> 
          {/* {item.image != null && item.image !== "" ?  <img src={item.image} alt="Uploaded Images" style={{maxHeight:"30px",maxWidth:"30px"}} /> :""} */}
          <Card.Body>
            <Card.Title>ทะเบียน : {item.carId} {item.province}</Card.Title>
            <Card.Text>
              เจ้าพนักงาน : จสอ. ขยัน ทำดี
              <br/>จุดเกิดเหตุ : พื้นที่ สน. บางรัก กทม
              <br/>วันเวลาเกิดเหตุ : 14:00 / 28 กันยายน 2563
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">สถานะ : ประสานงานรถลากจูง</small>
            <br/>
            <Button variant="warning" onClick={() => {handleShow();}}>แก้ไขสถานะ</Button>
            <Button variant="danger" onClick={() => onDelete(item.id)}>ยกเลิก</Button> 
          </Card.Footer>
        </Card>
      )):""}
      </CardColumns>
    </Container>


    <Modal show={show} onHide={handleClose} onChange={(e) =>inputRef} 
        {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered >
        <Modal.Header closeButton> 
          <Modal.Title>เปลี่ยนสถานะ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
            <Form.Group as={Row} >
                <Form.Label column sm={4}> สถานะ </Form.Label>
                <Col sm={8}>
                    <Select name={province_master} options={master[province_master]} selected={carCreate[province_master]} onChange={e => carCreateChange({province_master},{label:e.label, value:e.value})} />
                </Col>
            </Form.Group>
          </Form>
      </Modal.Body>
      <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}> Close </Button>
          {/* <Button variant="primary" onClick={handleClose}> Save Changes </Button> */}
          <Button variant="primary" onClick={()=>{onCreate(); handleClose();}}>Confirm Edit</Button> 
      </Modal.Footer>
  </Modal>




      {/* <Container>
        <Row>
          <Col>
            <Table striped bordered hover variant="white">
              <thead>
                <tr>
                  <th>IMG</th>
                  <th>Car Name</th>
                  <th>Select</th>
                  <th>Check</th>
                  <th></th>
                  <th>Start/Create</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {carList ? carList.map((item,index) => (
                  <tr key={item.id}>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 400 }}
                      overlay={renderTooltip(item)} >
                    <td>
                        {item.image != null && item.image !== "" ?  <img src={item.image} alt="Uploaded Images" style={{maxHeight:"30px",maxWidth:"30px"}} /> :""}
                    </td>
                    </OverlayTrigger>
                    <td>
                      <input type="text" name="name" value={item.name} onChange={e=>carUpdateChange(e.target.name, e.target.value, index)} />
                      <br/>Car <a href={"../webEdit/"+item.name}>Edit</a> / <a href={"../web/"+item.name}>Show</a>
                      <br/>Company<a href={"../company/"+item.id_company}>Edit</a> / <a href={"../company/"+item.id_company}>Show</a>
                    </td>
                    <td> {dateFormat(item.startDate)}<br/>{dateFormat(item.createDate)} </td>
                    <td> 
                      <Button className="text-white m1-4" variant="warning" onClick={() => onUpdate(item.id)}>U</Button>
                      <Button variant="danger" onClick={() => onDelete(item.id)}>D</Button> 
                    </td>
                  </tr>
                )):""}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container> */}
      








      <AuthUserContext.Consumer>
        { authUser => authUser && authUser.roles && !!authUser.roles["ADMIN"] && (
          <> 
            Create
            <hr/>
            {JSON.stringify(carCreate)}
            <hr/>
            Update
            <hr/>
            {JSON.stringify(carUpdate)}
            <hr/>
            List
            <hr/>
            {JSON.stringify(carList)}
          </>
        )}
      </AuthUserContext.Consumer>
  </div>
  </>
  );
}

class Page extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <PageFuction firebase={this.props.firebase} />
    );
  }
}

export default withFirebase(Page);